import React from 'react';
import { motion } from 'framer-motion';
import { MockupNavbar } from './MockupNavbar';
import { MockupHero } from './MockupHero';

const PHONE_HOVER = { rotate: -2, y: -8 };
const MOCKUP_INITIAL = { opacity: 0, scale: 0.9, rotate: -10 };
const MOCKUP_VISIBLE = { opacity: 1, scale: 1, rotate: -6 };
const MOCKUP_TRANSITION = { delay: 0.3, duration: 0.7 };

const ContactPhoneMockup = ({ isInView }) => (
  <motion.div
    initial={MOCKUP_INITIAL}
    animate={isInView ? MOCKUP_VISIBLE : MOCKUP_INITIAL}
    transition={MOCKUP_TRANSITION}
    whileHover={PHONE_HOVER}
    className="relative mx-auto"
    data-testid="contact-phone-mockup"
  >
    <div className="absolute -inset-4 sm:-inset-6 md:-inset-8 bg-gradient-to-br from-fuchsia-500/20 via-orange-500/15 to-blue-500/20 rounded-[3rem] blur-2xl" />
    <div className="relative w-36 h-[260px] sm:w-52 sm:h-[380px] md:w-64 md:h-[480px] lg:w-72 lg:h-[540px] mx-auto rounded-[1.5rem] sm:rounded-[2rem] md:rounded-[3rem] bg-gradient-to-br from-slate-800 to-slate-950 p-1.5 sm:p-2 shadow-2xl border border-white/10">
      <div className="relative w-full h-full rounded-[1.25rem] sm:rounded-[1.5rem] md:rounded-[2.5rem] overflow-hidden bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-[10%] left-[10%] w-20 h-20 sm:w-32 sm:h-32 bg-blue-500/15 rounded-full blur-2xl" />
          <div className="absolute bottom-[15%] right-[10%] w-24 h-24 sm:w-36 sm:h-36 bg-purple-500/15 rounded-full blur-2xl" />
        </div>
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-16 sm:w-20 md:w-28 h-4 sm:h-5 md:h-7 bg-black rounded-b-xl sm:rounded-b-2xl z-20" />
        <MockupNavbar />
        <MockupHero />
      </div>
    </div>
  </motion.div>
);

export default ContactPhoneMockup;
